// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"ChipsSlider_bannerImage__1LfF0","noBorder":"ChipsSlider_noBorder__2hVf0"};